import React from 'react';
import { Route, Switch } from 'react-router-dom';
import InventoryReportsForm from '../../../WMSReports/inventoryReports/index';
import DailyInventoryReportsForm from '../../../WMSReports/DailyInventoryReports/index';
import InboundPurchaseOrderReport from '../../../WMSReports/InboundPurchaseOrderReport/index';
import StorageReportsForm from '../../../WMSReports/storageReports/index';
import TransactionalReportsForm from '../../../WMSReports/transactionalReports/index';
import InboundDeliveryReport from '../../../WMSReports/InboundDeliveryReport/index';
import InboundAsnInvoiceReport from '../../../WMSReports/InboundAsnInvoiceReport/index';
import InboundReceivingReport from '../../../WMSReports/InboundReceivingReport/index';
import SalesReturnReportsForm from '../../../WMSReports/InboundSalesReturn/index';
import SalesReturnToGrReport from '../../../WMSReports/SalesReturnToGrReport/index';
import InventoryAllocationReport from '../../../WMSReports/OutboundInventoryAllocationReport/index';
import CldDispatchReport from '../../../WMSReports/OutboundCldDispatchReport/index';
import POToGRNReport from '../../../WMSReports/POToGRNReport/index';
import POSortReport from '../../../WMSReports/POSortReport/index';
import TransactionStatusReport from '../../../WMSReports/TransactionStatusReport/index';
import inboundReports from '../../../WMSReports/InboundReports/index';
import outboundReports from '../../../WMSReports/OutboundReports/index';
import PurchaseReturnReport from '../../../WMSReports/PurchaseReturnReport/index';
import MISPOToGRNReport from '../../../WMSReports/MISPOToGRNReport/index';
import MISSalesReturnToGrReport from '../../../WMSReports/MISSalesReturnToGrReport/index';
import IntegrationReport from '../../../WMSReports/IntegrationReport/components/IntegrationReport';
import StockMovementReport from '../../../WMSReports/StockMovementReport';
import CCFailureReport from '../../../WMSReports/CCFailureReport';
import InvoiceFailureReport from '../../../WMSReports/InvoiceFailureReport';
import InboundFailureReport from '../../../WMSReports/InboundFailureReport';
import TransactionFailureReport from '../../../WMSReports/TransactionFailureReport';
import InboundSrnFailureReport from '../../../WMSReports/InboundSrnFailureReport';
import STOTransaction from '../../../WMSReports/STOTransaction';
import DuesReport from '../../../WMSReports/DuesReport/index';
import StoReport from '../../../WMSReports/MisStoReport/index';
import HealthCheckReport from '../../../WMSReports/HealthCheckReport/index';
import BifurcationReport from '../../../WMSReports/BifurcationReports/index';
import lynkmandistockreport from '../../../WMSReports/LynkMandiStockReport/index';
import inventoryallocationanalysyis from '../../../WMSReports/InventoryAllocationAnalysisReport/index';
import billwisecasepicksheetreport from '../../../WMSReports/BillwiseToCasePIcksheetReport/index' ;
import ErpVsJarvisInventoryBrand from '../../../WMSReports/ErpVsJarvisInventoryBrandReport/index';
import ErpVsJarvisInventoryItem from '../../../WMSReports/ErpVsJarvisInventoryItemReport/index';
import InventoryMovementBrandLevel from '../../../WMSReports/InventoryMovementBrandLevel/index';
import InventoryMovementItemLevel from '../../../WMSReports/InventoryMovementItemLevel/index';
import PackedVsInvoiced from '../../../WMSReports/PackedvsInvoicedReport';
import CycleCountReport from '../../../WMSReports/CycleCountReport/index';
import MISCycleCountReport from '../../../WMSReports/MISCycleCountReport/index';
import MISSOToDispatchReport from '../../../WMSReports/MISSOToDispatchReport/index';
import MISItemTransactionReport from '../../../WMSReports/MISItemTransactionReport/index';
import MISCCVarianceReport from '../../../WMSReports/MISCCVarianceReport/index';
import BillVSPacking from '../../../WMSReports/BillVSPacking/index';
import MisFillRateReport from '../../../WMSReports/MisFillRateReport/index';
import BinConsolidationReport from '../../../WMSReports/BinConsolidationReport/index';
import TransitTransactionReport from '../../../WMSReports/TransitTransactionReport/index';
import PutawayReport from '../../../WMSReports/PutawayReport/index';
import PickTaskReport from '../../../WMSReports/PickTaskReport';
import BinToBinTransferReport from '../../../WMSReports/BInToBinTransfer/index';
import ErpVsJarvisInventoryInTransitReport from '../../../WMSReports/ErpVsJarvisInventoryInTransitReport/index'; 
import InboundSummaryReport from '../../../WMSReports/InboundSummaryReport/index';
import MisPurchaseReturnReport from '../../../WMSReports/MisPurchaseReturnReport/index';
import MisDispatchPendingReport from '../../../WMSReports/MisDispatchPendingReport/index';
import MisNewFillRateReport from '../../../WMSReports/MisNewFillRateReport/index';
import PendingOrderVsAvailableQty from '../../../WMSReports/PendingOrderVsAvailableQty/index';
import PackedCrateReport from '../../../WMSReports/PackedCrateReport/index';
import MisPackedCrateReport from '../../../WMSReports/MisPackedCrateReport/index';
import MisWeightedAvgReport from '../../../WMSReports/MisWeightedAvgReport/index';
import MisPackingTaskReport from '../../../WMSReports/MisPackingTaskReport/index';
import InvoiceDownload from '../../../WMSReports/InvoiceDownload/index';
import ExpiryReport from '../../../WMSReports/ExpiryReport/index';
import StagingReport from '../../../WMSReports/StagingReport';

export default () => (
  <Switch>
    <Route path="/wmsReports/inventoryReports" component={InventoryReportsForm} />
    <Route path="/wmsReports/daily_inventoryReports" component={DailyInventoryReportsForm} />
  	<Route path="/wmsReports/storageReports" component={StorageReportsForm} />
  	<Route path="/wmsReports/transactionalReports" component={TransactionalReportsForm} />
    <Route path="/wmsReports/purchase" component={InboundPurchaseOrderReport} />
    <Route path="/wmsReports/inbound_delivery" component={InboundDeliveryReport} />
    <Route path="/wmsReports/asn_invoice" component={InboundAsnInvoiceReport} />
    <Route path="/wmsReports/receiving" component={InboundReceivingReport} />
    <Route path="/wmsReports/sales_return" component={SalesReturnReportsForm} />
    <Route path="/wmsReports/sales_return_gr" component={SalesReturnToGrReport} />
    <Route path="/wmsReports/mis_sales_return_gr" component={MISSalesReturnToGrReport} />

    <Route path="/wmsReports/inventory_allocation_report" component={InventoryAllocationReport} />
    <Route path="/wmsReports/cld_dispatch_report" component={CldDispatchReport} />
    <Route path="/wmsReports/health_check_report" component={HealthCheckReport} />  
    <Route path="/wmsReports/po_to_grn_report" component={POToGRNReport} /> 
    <Route path="/wmsReports/transaction_status_report" component={TransactionStatusReport} /> 
    <Route path="/wmsReports/inbound_reports" component={inboundReports} />  

    <Route path="/wmsReports/outbound_reports" component={outboundReports} /> 
    <Route path="/wmsReports/mis_po_to_grn_report" component={MISPOToGRNReport} />  
    <Route path="/wmsReports/po_sort_report" component={POSortReport} /> 
    <Route path="/wmsReports/purchase_return_report" component={PurchaseReturnReport} />  
    <Route path="/wmsReports/bifurcation_report" component={BifurcationReport} />
    <Route path="/wmsReports/lynk_mandi_stock_report" component={lynkmandistockreport} />
    <Route path="/wmsReports/inventory_allocation_analysis_report" component={inventoryallocationanalysyis} />
    <Route path="/wmsReports/billwise_to_case_picksheet_report" component={billwisecasepicksheetreport} />
    <Route path="/wmsReports/brand_inventoryReports" component={ErpVsJarvisInventoryBrand} />
    <Route path="/wmsReports/item_inventoryReports" component={ErpVsJarvisInventoryItem} />
     <Route path="/wmsReports/inventory_movement_brand" component={InventoryMovementBrandLevel} />
    <Route path="/wmsReports/inventory_movement_item" component={InventoryMovementItemLevel} />
    <Route path="/wmsReports/packed_vs_invoiced" component={PackedVsInvoiced} />
    <Route path="/wmsReports/cycle_count_report" component={CycleCountReport} />
    <Route path="/wmsReports/mis_cycle_count_report" component={MISCycleCountReport} />
    <Route path="/wmsReports/mis_cc_variance_report" component={MISCCVarianceReport} />
    <Route path="/wmsReports/mis_so_to_dispatch" component={MISSOToDispatchReport} />
    <Route path="/wmsReports/mis_item_wise_transaction" component={MISItemTransactionReport} />
    <Route path="/wmsReports/integration_report" component={IntegrationReport} />
    <Route path = "/wmsReports/stock_movement" component = {StockMovementReport}/> 
    <Route path = "/wmsReports/cc_failure" component = {CCFailureReport}/>
    <Route path = "/wmsReports/invoice_failure" component = {InvoiceFailureReport}/>
    <Route path = "/wmsReports/inbound_failure" component = {InboundFailureReport}/>
    <Route path = "/wmsReports/inbound_srn_failure" component = {InboundSrnFailureReport}/>
    <Route path = "/wmsReports/transaction_failure" component = {TransactionFailureReport}/>
    <Route path = "/wmsReports/sto_transaction" component = {STOTransaction}/>
    <Route path = "/wmsReports/dues_report" component = {DuesReport}/>
    <Route path = "/wmsReports/sto_report" component = {StoReport}/>
    <Route path = "/wmsReports/packing_station_summary" component = {BillVSPacking}/>
    <Route path="/wmsReports/fill_rate_report" component={MisFillRateReport} />
    <Route path="/wmsReports/reports/binconsolidation" component={BinConsolidationReport} />
    <Route path="/wmsReports/intransit/transaction" component={TransitTransactionReport} />
    <Route path="/wmsReports/putaway_report" component={PutawayReport} />
    <Route path="/wmsReports/pick_task_report" component={PickTaskReport} />
    <Route path="/wmsReports/bin_transfer_report" component={BinToBinTransferReport} />
    <Route path="/wmsReports/erp_jarvis_intransit_inventory_report" component={ErpVsJarvisInventoryInTransitReport} />
    <Route path="/wmsReports/inbound_summary_report" component={InboundSummaryReport} />
    <Route path="/wmsReports/mis/purchase_return_report" component={MisPurchaseReturnReport}/>
    <Route path="/wmsReports/mis/dispatch_diff_report" component={MisDispatchPendingReport}/>
    <Route path="/wmsReports/new_fill_rate_report" component={MisNewFillRateReport} />
    <Route path="/wmsReports/pending_order_vs_available_qty" component={PendingOrderVsAvailableQty} />
    <Route path="/wmsReports/packed_crate_report" component={PackedCrateReport} />
    <Route path="/wmsReports/mis_packed_crate_report" component={MisPackedCrateReport} />
    <Route path="/wmsReports/mis_weighted_avg_report" component={MisWeightedAvgReport} />
    <Route path="/wmsReports/mis_packing_report" component={MisPackingTaskReport} />
    <Route path="/wmsReports/expiry_report" component={ExpiryReport} />
    <Route path="/wmsReports/staging_report" component={StagingReport} />

  </Switch>
);
